import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { MissingPermissionsSheetProps } from '../missing-permissions-sheet';
const useLocalSheet = () => {
  const $ = _c(6);
  const [sheet, setSheet] = useState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = props => {
      setSheet({
        ...props,
        open: true
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const show = t0;
  let t1;
  if ($[1] !== sheet) {
    t1 = () => {
      if (!sheet) {
        return;
      }
      setSheet(_temp);
    };
    $[1] = sheet;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const hide = t1;
  let t2;
  if ($[3] !== hide || $[4] !== sheet) {
    t2 = {
      sheet,
      show,
      hide
    };
    $[3] = hide;
    $[4] = sheet;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default useLocalSheet;
function _temp(currentSheet) {
  if (!currentSheet) {
    return;
  }
  return {
    ...currentSheet,
    open: false
  };
}